module.exports = __webpack_public_path__ + "img/4.42c39ac0.jpeg";